/**
 * Response information carried by an HTTP error,
 * a structural subset of what any transport can provide
 */
export type HttpErrorResponse = {
  status: number
  statusText: string
  url: string
  headers: Headers
}

/**
 * Base error class for all request errors
 */
export class RequestError extends Error {
  constructor(error: Error | string) {
    super(typeof error === 'string' ? error : error.message)
  }
}

/**
 * HTTP error
 */
export class RequestHttpError extends RequestError {
  public readonly response: HttpErrorResponse

  constructor(response: HttpErrorResponse) {
    super('HTTP error: ' + response.status + ' ' + response.statusText)

    this.response = response
    this.name = 'RequestHttpError'
  }
}

/**
 * Request failed error
 */
export class RequestFailedError extends RequestError {
  public readonly failure: Error

  constructor(failure: Error) {
    super(failure)

    this.failure = failure
    this.name = 'RequestFailedError'
  }
}

/**
 * Request failed due to cancel error
 */
export class RequestCancelledError extends RequestFailedError {
  public override readonly failure: Error

  constructor(failure: Error) {
    super(failure)

    this.failure = failure
    this.name = 'RequestCancelledError'
  }
}

/**
 * Request failed due to timeout error
 */
export class RequestTimeoutError extends RequestFailedError {
  public override readonly failure: Error

  constructor(failure: Error) {
    super(failure)

    this.failure = failure
    this.name = 'RequestTimeoutError'
  }
}
